import React from 'react';

const MapExportSection = ({ mapResults, exportMapData }) => {
  if (mapResults.length === 0) return null;

  return (
    <div style={{
      marginTop: 25,
      background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(253, 230, 138, 0.15))',
      borderRadius: 16,
      padding: 20,
      border: '1px solid rgba(245, 158, 11, 0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 15
    }} data-testid="map-export-section">
      <div style={{ flex: 1, minWidth: 200 }}>
        <h3 style={{ color: '#f59e0b', margin: '0 0 8px 0', display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{
            background: 'linear-gradient(135deg, #f59e0b, #FDE68A)',
            padding: '2px 8px',
            borderRadius: 6,
            fontSize: '0.65rem',
            color: '#0F172A'
          }}>PREMIUM</span>
          📊 Export Map Data
        </h3>
        <p style={{ color: '#a1a1aa', fontSize: '0.85rem', margin: 0 }}>
          Download your mapped results as CSV or JSON for analysis and research!
        </p>
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        <button
          onClick={() => exportMapData('csv')}
          className="btn btn-primary"
          style={{
            background: 'linear-gradient(135deg, #10b981, #06b6d4)',
            display: 'flex',
            alignItems: 'center',
            gap: 6
          }}
          data-testid="export-csv-btn"
        >
          📄 Export CSV
        </button>
        <button
          onClick={() => exportMapData('json')}
          className="btn btn-primary"
          style={{
            background: 'linear-gradient(135deg, #FCD34D, #FDE68A)',
            display: 'flex',
            alignItems: 'center',
            gap: 6
          }}
          data-testid="export-json-btn"
        >
          📋 Export JSON
        </button>
      </div>
    </div>
  );
};

export default MapExportSection;
